import { render, staticRenderFns } from "./PostitNote.vue?vue&type=template&id=7ba0b5b1&scoped=true"
import script from "./PostitNote.vue?vue&type=script&lang=js"
export * from "./PostitNote.vue?vue&type=script&lang=js"
import style0 from "./PostitNote.vue?vue&type=style&index=0&id=7ba0b5b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba0b5b1",
  null
  
)

export default component.exports